// Fetch wrapper for admin API calls. Like public-client, but always sends the
// session cookie (`credentials: 'include'`) so the server can authorize the
// request, and surfaces 401s as a typed error so the auth slice can react.
// Pass `body` as a plain object — it is JSON-stringified automatically.
export class AdminAuthError extends Error {}

export const adminFetch = async (path, { body, headers, ...rest } = {}) => {
  const isJson = body != null && !(body instanceof FormData);
  const resp = await fetch(path, {
    credentials: 'include',
    headers: isJson ? { 'Content-Type': 'application/json', ...headers } : headers,
    body: isJson ? JSON.stringify(body) : body,
    ...rest,
  });
  if (resp.status === 401) {
    throw new AdminAuthError('Your session has expired. Please sign in again.');
  }
  if (!resp.ok) {
    const err = await resp.json().catch(() => ({}));
    throw new Error(err.error || `Request failed (${resp.status})`);
  }
  return resp.json();
};
